/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Level_BlockedInputs */

const en_us2_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level the phone to unlock the shutter.`)
};

const pt_br2_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivele o celular para liberar a foto.`)
};

const es_419_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivela el teléfono para activar el disparador.`)
};

const pt_pt2_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivela o telemóvel para desbloquear a foto.`)
};

const fr_fr2_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mets le téléphone de niveau pour débloquer la photo.`)
};

const de_de2_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richte das Handy gerade aus, um den Auslöser freizugeben.`)
};

const it_it2_body_assessment_level_blocked = /** @type {(inputs: Body_Assessment_Level_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti il telefono in bolla per sbloccare lo scatto.`)
};

/**
* | output |
* | --- |
* | "Level the phone to unlock the shutter." |
*
* @param {Body_Assessment_Level_BlockedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_level_blocked = /** @type {((inputs?: Body_Assessment_Level_BlockedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Level_BlockedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_level_blocked(inputs)
	if (locale === "es-419") return es_419_body_assessment_level_blocked(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_level_blocked(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_level_blocked(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_level_blocked(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_level_blocked(inputs)
	return en_us2_body_assessment_level_blocked(inputs)
});
export { body_assessment_level_blocked as "body-assessment.level_blocked" }